import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {
    httpCreateSiarBulkExport,
    HttpCreateSiarBulkExportPayload,
    HttpCreateSiarBulkExportResponse,
    NoEligibleProjectsError
} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'

export const useStoreSiarBulkExport = (
    options?: Omit<
        UseMutationOptions<
            HttpCreateSiarBulkExportResponse,
            AxiosError<NoEligibleProjectsError>,
            HttpCreateSiarBulkExportPayload
        >,
        'mutationKey' | 'mutationFn'
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.BULK_SIAR_EXPORT],
        mutationFn: payload => httpCreateSiarBulkExport({payload}),
        onSettled: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_HISTORY]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_EXPORT_DETAIL]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_PREVIEW]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_PREVIEW_COUNTERS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            options?.onSettled?.(...args)
        }
    })
}
